/*
 * Copyright (c) 2024. Tooling Team
 */

/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { AuthConsumer } from "../providers/authProvider";
import { AuthLoading } from "../components/auth/authLoading";
import { getLabDomainVisibility } from "../utils/featureSettings";

export const PrivateRoute = ({
  component,
  requiresLabDomain = false,
  ...rest
}) => {
  const renderFn = (Component) => (props) =>
    (
      <AuthConsumer>
        {({ isAuthenticated, signinRedirect }) => {
          if (!!Component && isAuthenticated()) {
            if (requiresLabDomain && !getLabDomainVisibility()) {
              return <Redirect to="/" />;
            }

            return <Component {...props} />;
          } else {
            signinRedirect();
            return <AuthLoading />;
          }
        }}
      </AuthConsumer>
    );

  return <Route {...rest} render={renderFn(component)} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.func,
  requiresLabDomain: PropTypes.bool,
};
